
import {defineComponent} from "vue";
import GreenButton from "@/components/GreenButton.vue";

export default defineComponent({
  name: "StartPage",
  components: {GreenButton},
  data() {
    return {
      show: false,
    }
  },
  mounted() {
    this.show = true;
  }
})
